import { API_MAP, agent } from 'helpers';

import type IPagination from 'interfaces/IPagination';

class NewzzService {
  static list(pagination?: IPagination) {
    return agent.get(`${API_MAP.listAllNewzz}`, pagination);
  }

  static loadById(id: number) {
    return agent.get(`${API_MAP.loadNewzz}/${id}`);
  }

  static clickNewzz(id: any) {
    return agent.post(API_MAP.clickNewzz.replace('{id}', id), {});
  }
}
export default NewzzService;
